module.exports = __webpack_public_path__ + "static/media/logofoco.1dab7051.png";